<template>
  <el-dialog
    width="400px"
    :visible="visible"
    :lock-scroll="false"
    :destroy-on-close="true"
    custom-class="ele-dialog-form"
    title="订单推送"
    @update:visible="updateVisible">
    <el-form ref="form" :model="form" :rules="rules" @keyup.enter.native="save" @submit.native.prevent>
      <el-form-item prop="payerName">
        <el-input clearable v-model="form.payerName" placeholder="请输入" />
      </el-form-item>
      <el-form-item prop="paymentAmount">
        <el-input clearable v-model="form.paymentAmount" placeholder="请输入" />
      </el-form-item>
      <el-form-item :prop="authFieldProp">
        <el-input
          clearable
          v-model="form[authFieldProp]"
          :type="useGoogleAuth ? 'text' : 'password'"
          placeholder="请输入"
          :show-password="!useGoogleAuth" />
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="updateVisible(false)">取消</el-button>
      <el-button type="primary" :loading="loading" @click="save">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'TuisEdit',
  props: {
    visible: Boolean,
    data: Object,
    admin_user_id: [String, Number]
  },
  data() {
    return {
      form: Object.assign({ status: 1, google_token: '', password: '' }, this.data || {}),
      loading: false
    };
  },
  computed: {
    useGoogleAuth() {
      const user = this.$store.state.user && this.$store.state.user.user;
      return !!(user && Number(user.is_google) === 1);
    },
    authFieldProp() {
      return this.useGoogleAuth ? 'google_token' : 'password';
    },
    rules() {
      return {
        payerName: [{ required: true, message: '请输入', trigger: 'blur' }],
        paymentAmount: [{ required: true, message: '请输入', trigger: 'blur' }],
        google_token: this.useGoogleAuth
          ? [{ required: true, message: '请输入', trigger: 'blur' }]
          : [],
        password: !this.useGoogleAuth
          ? [{ required: true, message: '请输入', trigger: 'blur' }]
          : []
      };
    }
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({ google_token: '', password: '' }, this.data);
      } else {
        this.form = { status: 1, google_token: '', password: '' };
      }
    },
    visible(value) {
      if (value) {
        this.form.google_token = '';
        this.form.password = '';
      }
    }
  },
  methods: {
    save() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        this.loading = true;
        const payload = {
          ...this.form,
          admin_user_id: this.admin_user_id
        };
        this.$http
          .post('/inorder/changePayorder', payload)
          .then((res) => {
            this.loading = false;
            if (res.data.code === 0) {
              this.$message.success(res.data.msg);
              this.updateVisible(false);
              this.$emit('done');
            } else {
              this.$message.error(res.data.msg);
            }
          })
          .catch((e) => {
            this.loading = false;
            this.$message.error(e.message);
          });
      });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    }
  }
};
</script>
